/** EN uses Swedish values until translated. */
export const pagesCalendarEn = {
    legend: {
        title: 'Explanation',
        incRights: 'Last day inc. rights',
        exRights: 'First trading day ex. rights',
        rightsEnd: 'Last trading day of sub rights',
        subscription: 'Subscription period',
        ipo: 'First day of trading',
    },
    chips: {
        inc: 'Inc',
        ex: 'Ex',
        tr: 'Rights',
        subscription: 'Sub',
        ipo: 'IPO',
    },
    filters: {
        completedIssuesAndOptions: 'Completed issues and warrants',
        unlistedOptions: 'Unlisted warrants',
        lists: 'Marketplaces',
        financialAdvisor: 'Financial advisor',
        others: 'Other',
    },
    tooltip: {
        subscriptionPrice: 'Sub price',
        perUnit: 'per unit',
        perShare: 'per share',
        unit: 'Unit',
        list: 'Marketplace',
        financialAdvisor: 'Financial advisor',
        noFinancialAdvisor: 'No financial advisor',
        warrantsPlaceholder: 'X warrants',
        sharesPlaceholder: 'X shares',
    },
    size: {
        noNewShares: 'No new shares will be issued',
        notYetDetermined: 'Not yet defined',
    },
}
